import * as React from "react";
import { useHistory } from "react-router";
import {
  SecureGateRoute,
  BreadCrumb,
  DetailBotLogModal,
} from "../../components";
import { Information } from "../../components/core"
import { AppSettings } from "../../configs";
import { ExtendConsiderationPeriodTable } from "../../components/ExtendConsiderationPeriod";
import ExtendConsiderationPeriodService from '../../services/ExtendConsiderationPeriodService'
import { msg } from '../../components/Notifications/MsgBox';
import Avatar from '@material-ui/core/Avatar';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import UserServices from '../../services/UserServices';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
    maxWidth: 350
  },
}));



const ExtendConsiderationPeriodScreen = () => {

  const classes = useStyles();
  const history = useHistory();
  const [openLoading,setOpenLoading]= React.useState(false)
  const [items,setItems]= React.useState([])
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [appReadonly,setAppReadonly] = React.useState(true);

  const handleApplicationCheckReadonly = async () =>
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                setAppReadonly(false)
            }
        })
    }

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlerAddClick = () => {
    history.push(`/ExtendConsiderationPeriodItem/0`);
  }

  const handlerOnClickRow = (obj) => {
    history.push(`/ExtendConsiderationPeriodItem/${obj.transaction_no}`);
  }

  function ShowsLoading(props) {
    const { isLoading } = props;
    return (
        (isLoading ?
            <div id="loading-element">
                <div id="loading-indicator">
                    <div className="lds-ripple"><div></div><div></div></div>
                </div>
            </div>
            : null)
    )
}

  React.useEffect(()=>{
    handleApplicationCheckReadonly();
    setOpenLoading(true)
    ExtendConsiderationPeriodService.getExtendConsiderationPeriodAll().then(response=>{
      if(response.success)
      {
        setItems(response.data);
      }else{
        msg.error(response.message)
      }
      setOpenLoading(false)
    }).catch(error=>{
      setOpenLoading(false)
      msg.error(error?.message ?? 'Network error.')
    })
  },[])

  const open = Boolean(anchorEl);

  return (
    <div className="tor tor-template-list">
      <ShowsLoading isLoading={openLoading} ></ShowsLoading>
      <SecureGateRoute />
      <div id="main-content">
        <div className="page-body">
          <BreadCrumb
            breadcrumb={[
              { name: "RRS Home", url: AppSettings.defaultUrl },
              { name: "ขยายระยะเวลาพิจารณา", url: "" },
            ]}
          ></BreadCrumb>

          <div className="sp-page-header-panel row">
            <div className="col-md-5 sp-page-header">
              <h1 className="sp-page-header1">ขยายระยะเวลาพิจารณา</h1>
            </div>
          </div>

          <div className="sp-page-result-container">
            <div className="row sp-pagination-control-top">
              <div className="col-auto create-button" style={{height: '20px'}}>
              { appReadonly == false && <span
                  className="sp-bt-addmore"
                  onClick={handlerAddClick}
                >
                  <i className="icon btn-plus" />
                  <span>เพิ่ม</span>
                </span>}
              </div>
              <Avatar alt="!" src="../assets/images/icons/icon-info.svg" style={{width: 22, height: 22, position: 'absolute', right: 50, marginTop: 15}} 
              aria-owns={open ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={handlePopoverOpen}
              onMouseLeave={handlePopoverClose}
              />
              <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                  paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
              >
                <Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ในการตรวจรับงานแต่ละงวด คณะกรรมการตรวจรับพัสดุต้องดำเนินการให้แล้วเสร็จภายในกำหนดระยะเวลาในการพิจารณาของคณะกรรมการตรวจรับพัสดุ โดยเริ่มนับตั้งแต่วันที่ส่งมอบถูกต้องครบถ้วนจนถึงวันที่คณะกรรมการตรวจรับพัสดุทุกคนต้องดำเนินการตรวจรับและยืนยันข้อมูลบันทึกการตรวจรับ (MOM) ในระบบ RRS ให้แล้วเสร็จ ทั้งนี้ หากมีเหตุที่ทำให้การดำเนินงานล่าช้า จะต้องเสนอผู้มีอำนาจอนุมัติสั่งซื้อสั่งจ้างพัสดุพิจารณาขยายเวลาให้ตามความจำเป็น</Typography>
              </Popover>
            </div>
            <ExtendConsiderationPeriodTable
              items={items}
              onRowClick={handlerOnClickRow}
            ></ExtendConsiderationPeriodTable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtendConsiderationPeriodScreen;
